import { css } from "../../../styled-system/css";

export const styles = {
  root: (hasImage: boolean) =>
    css({
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateAreas: `
        "partnerLogo"
        "title"
        "loader"
        "image"
        "contentAfterRecordCheck"
      `,
      maxWidth: "1200px",
      margin: "0 auto",
      paddingX: "baseUnit.mobile4",
      desktop: {
        paddingX: "baseUnit.mobile16",
        ...(hasImage && {
          gridTemplateColumns: "1fr 1fr",
          gridTemplateAreas: `
              "partnerLogo image"
              "title image"
              "loader image"
              "contentAfterRecordCheck image"
            `,
          columnGap: "baseUnit.mobile2",
        }),
      },
      "& b": {
        fontWeight: 700,
      },
    }),
  title: () =>
    css({
      gridArea: "title",
      marginBottom: "baseUnit.mobile2",
    }),
  loader: () =>
    css({
      gridArea: "loader",
      marginY: "baseUnit.mobile3",
      "& div": {
        minHeight: "100%",
      },
      desktop: {
        marginY: "auto",
      },
    }),
  partnerLogo: () =>
    css({
      gridArea: "partnerLogo",
      marginTop: "0",
      marginBottom: "baseUnit.mobile2",
      desktop: {
        marginBottom: "baseUnit.mobile1",
      },
    }),
};
